// export const groupIterableByAttribute = (iterable: Array<Record<string, any>>, attribute: string): Record<string, Array<any>> => {
//   const iterableByAttribute = {};
//
//   iterable.forEach((item) => {
//     const value: any = item[attribute];
//     if (iterableByAttribute[value]) {
//       iterableByAttribute[value].push(item);
//     } else {
//       iterableByAttribute[value] = [item];
//     }
//   });
//
//   return iterableByAttribute;
// };

export const mapIterableByAttribute = (iterable: Array<Record<string, any>>, attribute: string): Record<string, any> => {
  const iterableByAttribute = {};

  iterable.forEach((item) => {
    // @ts-ignore
    iterableByAttribute[item[attribute]] = item;
  });

  return iterableByAttribute;
};
